export default __webpack_public_path__ + "static/code-copy.url-89e9e41917caa271d4749bb6129ad53c.svg";